<template>
    <div class="app-layout">
        <NavBar v-if="showNavBar" />
        <div class="content" :class="{ 'with-navbar': showNavBar }">
            <slot></slot>
        </div>
    </div>
</template>

<script>
import NavBar from './NavBar.vue';

export default {
    name: 'AppLayout',
    components: {
        NavBar
    },
    computed: {
        showNavBar() {
            return this.$route.meta.requiresAuth && !this.$route.meta.requiresScoringAuth;
        }
    }
};
</script>

<style scoped>
.app-layout {
    min-height: 100vh;
    position: relative;
}

.content {
    padding-top: 0;
}

.content.with-navbar {
    padding-top: 50px;
}
</style> 